import { supabase } from "./supabase";

/** A song as the catalogue knows it — not yet analysed, maybe never. */
export interface CatalogTrack {
  key: string;
  catalogId: string;
  artist: string;
  title: string;
  album: string;
  duration: number | null;
  artwork: string;
  year: string;
  versions: number;
  slug: string;
}

/**
 * Search every song that exists, not just the ones we have chords for.
 *
 * This runs in an edge function because iTunes sends no CORS headers, so the
 * browser cannot ask it directly. Results are cached server-side for a week.
 */
export async function searchCatalog(query: string): Promise<CatalogTrack[]> {
  const { data, error } = await supabase.functions.invoke("search-catalog", {
    body: { q: query },
  });
  if (error) return [];
  return (data?.results ?? []) as CatalogTrack[];
}
